import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-hero',
    templateUrl: './block-hero.component.html',
})

export class BlockHeroComponent extends BlockAbstractComponent implements OnInit {

}
